import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_662_46)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 4,
				width: 42,
				height: 42,
				rx: 21,
				fill: "#F7F8FA"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M24.8369 29C29.4166 29 33.2112 25.1744 33.2112 20.4091C33.2112 15.7109 29.4166 11.8182 24.8369 11.8182C20.1918 11.8182 16.4626 15.7109 16.4626 20.4091C16.4626 25.1744 20.1918 29 24.8369 29ZM28.1081 32.2216H21.5003C15.2195 32.2216 10.1818 37.4567 10.1818 43.8999C10.1818 45.1751 11.1632 46.1818 12.4063 46.1818H37.2021C38.4452 46.1818 39.492 45.1751 39.492 43.8999C39.492 37.4567 34.3889 32.2216 28.1081 32.2216Z",
				fill: "#282A33"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.5,
			y: 5.5,
			width: 39,
			height: 39,
			rx: 19.5,
			stroke: "#F7F8FA",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_662_46",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 4,
				width: 42,
				height: 42,
				rx: 21,
				fill: "white"
			})
		}) })
	]
});
export default SvgUser;
